// Brand assets (uploaded by client)
export const ASSETS = {
  logo: "https://customer-assets-wrfwihn1.emergentagent.net/job_9dcd202e-ad74-4a84-b55e-024e60285b09/artifacts/xh53gh24_higher-ground-logo.png",
  promoFlyer: "https://customer-assets-jai6qajn.emergentagent.net/job_hgdc-preview/artifacts/wj9963kj_PHOTO-2026-07-19-08-19-46.jpg",
  heroVideo: "https://customer-assets-wrfwihn1.emergentagent.net/job_9dcd202e-ad74-4a84-b55e-024e60285b09/artifacts/4uy8dpwc_HigherGround420RecapPG.mp4",
  exteriorWide: "https://customer-assets-jai6qajn.emergentagent.net/job_hgdc-preview/artifacts/g6tarkv1_DJI_0567.webp",
  exteriorMural: "https://customer-assets-jai6qajn.emergentagent.net/job_hgdc-preview/artifacts/s417hbwr_DJI_0566.webp",
  groupPatio: "https://customer-assets-jai6qajn.emergentagent.net/job_hgdc-preview/artifacts/tjxilkxv_A7V09214.webp",
  soundBath: "https://customer-assets-jai6qajn.emergentagent.net/job_hgdc-preview/artifacts/xgrqwxmi_A7V09204.webp",
  brandedBags: "https://customer-assets-jai6qajn.emergentagent.net/job_hgdc-preview/artifacts/jx1936xh_A7V09195.webp",
  juiceSeated: "https://customer-assets-jai6qajn.emergentagent.net/job_hgdc-preview/artifacts/0s5a207u_A7V09184.webp",
  juiceHighMaintenance: "https://customer-assets-jai6qajn.emergentagent.net/job_hgdc-preview/artifacts/n8zokdvp_A7V09182.webp",
  productFlatlay: "https://customer-assets-jai6qajn.emergentagent.net/job_hgdc-preview/artifacts/kn65yglq_A7V09181.webp",
  canWoman: "https://customer-assets-jai6qajn.emergentagent.net/job_hgdc-preview/artifacts/jw1ze9nk_A7V09174.webp",
  yogaFlow: "https://customer-assets-jai6qajn.emergentagent.net/job_hgdc-preview/artifacts/k411opjt_A7V09160.webp",
  chocPour: "https://customer-assets-jai6qajn.emergentagent.net/job_hgdc-preview/artifacts/3ejheqzv_A7V08332.webp",
  edibleFlatlay: "https://customer-assets-jai6qajn.emergentagent.net/job_hgdc-preview/artifacts/1q50lp3n_A7V08402.webp",
  pinkFoxBag: "https://customer-assets-jai6qajn.emergentagent.net/job_hgdc-preview/artifacts/jr2r7v3n_A7V08860.webp",
  pinkFoxCookies: "https://customer-assets-jai6qajn.emergentagent.net/job_hgdc-preview/artifacts/pt3rgqss_A7V08875.webp",
  popcornRig: "https://customer-assets-jai6qajn.emergentagent.net/job_hgdc-preview/artifacts/mq8xgh6i_A7V08759.webp",
  comedyStage: "https://customer-assets-jai6qajn.emergentagent.net/job_hgdc-preview/artifacts/jkvem26c_A7V09782.webp",
  comedyCrowd: "https://customer-assets-jai6qajn.emergentagent.net/job_hgdc-preview/artifacts/tq18qq0e_A7V09790.webp",
  comedyLaugh: "https://customer-assets-jai6qajn.emergentagent.net/job_hgdc-preview/artifacts/zglbwnxz_A7V09793.webp",
  comedyPortrait: "https://customer-assets-jai6qajn.emergentagent.net/job_hgdc-preview/artifacts/p1rbbhr8_A7V09797.webp",
  counterService: "https://customer-assets-jai6qajn.emergentagent.net/job_hgdc-preview/artifacts/2d7vxh6a_A7V09776%20%281%29.webp",
};

// Media gallery (client-uploaded photography)
export const MEDIA = [
  { src: "https://customer-assets-jai6qajn.emergentagent.net/job_hgdc-preview/artifacts/20aoz1c5_A7V00201.webp", label: "Sound Bath & Breathwork", span: "tall" },
  { src: "https://customer-assets-jai6qajn.emergentagent.net/job_hgdc-preview/artifacts/ja978aea_A7V09772.webp", label: "Comedy Night — Higher Ground DC", span: "tall" },
  { src: "https://customer-assets-jai6qajn.emergentagent.net/job_hgdc-preview/artifacts/79n79qck_A7V00202.webp", label: "Community Yoga Flow", span: "tall" },
  { src: "https://customer-assets-jai6qajn.emergentagent.net/job_hgdc-preview/artifacts/zs7allee_A7V00248.webp", label: "Outdoor Pilates & Wellness", span: "tall" },
  { src: "https://customer-assets-jai6qajn.emergentagent.net/job_hgdc-preview/artifacts/lyc4c3bj_A7V00183.webp", label: "Yoga on the Patio", span: "tall" },
  { src: "https://customer-assets-jai6qajn.emergentagent.net/job_hgdc-preview/artifacts/g6tarkv1_DJI_0567.webp", label: "The Home — Union Market", span: "wide" },
  { src: "https://customer-assets-jai6qajn.emergentagent.net/job_hgdc-preview/artifacts/3ejheqzv_A7V08332.webp", label: "Craft Edibles", span: "tall" },
  { src: "https://customer-assets-jai6qajn.emergentagent.net/job_hgdc-preview/artifacts/jr2r7v3n_A7V08860.webp", label: "Pink Fox — DC's Original Edible", span: "tall" },
  { src: "https://customer-assets-jai6qajn.emergentagent.net/job_hgdc-preview/artifacts/tjxilkxv_A7V09214.webp", label: "Community Wellness Mornings", span: "wide" },
  { src: "https://customer-assets-jai6qajn.emergentagent.net/job_hgdc-preview/artifacts/xgrqwxmi_A7V09204.webp", label: "Pilates & Sound Bath", span: "wide" },
  { src: "https://customer-assets-jai6qajn.emergentagent.net/job_hgdc-preview/artifacts/jx1936xh_A7V09195.webp", label: "Signature Packaging", span: "tall" },
  { src: "https://customer-assets-jai6qajn.emergentagent.net/job_hgdc-preview/artifacts/pt3rgqss_A7V08875.webp", label: "Handmade in Washington DC", span: "tall" },
  { src: "https://customer-assets-jai6qajn.emergentagent.net/job_hgdc-preview/artifacts/jw1ze9nk_A7V09174.webp", label: "Higher Ground Hydration", span: "tall" },
  { src: "https://customer-assets-jai6qajn.emergentagent.net/job_hgdc-preview/artifacts/mq8xgh6i_A7V08759.webp", label: "The Craft Lab", span: "tall" },
  { src: "https://customer-assets-jai6qajn.emergentagent.net/job_hgdc-preview/artifacts/1q50lp3n_A7V08402.webp", label: "Curated Edibles", span: "wide" },
  { src: "https://customer-assets-jai6qajn.emergentagent.net/job_hgdc-preview/artifacts/0s5a207u_A7V09184.webp", label: "The Higher Ground Community", span: "tall" },
  { src: "https://customer-assets-jai6qajn.emergentagent.net/job_hgdc-preview/artifacts/jkvem26c_A7V09782.webp", label: "Comedy Night on the Patio", span: "wide" },
  { src: "https://customer-assets-jai6qajn.emergentagent.net/job_hgdc-preview/artifacts/p1rbbhr8_A7V09797.webp", label: "Good Times at Higher Ground", span: "tall" },
  { src: "https://customer-assets-jai6qajn.emergentagent.net/job_hgdc-preview/artifacts/zglbwnxz_A7V09793.webp", label: "Laughs & Community", span: "wide" },
  { src: "https://customer-assets-jai6qajn.emergentagent.net/job_hgdc-preview/artifacts/2d7vxh6a_A7V09776%20%281%29.webp", label: "Patient-First Service", span: "wide" },
  { src: "https://customer-assets-jai6qajn.emergentagent.net/job_hgdc-preview/artifacts/s417hbwr_DJI_0566.webp", label: "The Mural", span: "tall" },
];

export const LINKS = {
  menu: "https://highergroundcannabis.dispensary.shop/med/menu",
  waiver: "https://waiver.smartwaiver.com/w/ucpaz2irfce6jx1tuvhkes/web/",
  registerDC: "https://myabca.dc.gov/s/login/SelfRegister?language=en_US",
  registerNonDC: "https://myabca.dc.gov/s/unauthenticated-non-dc-form?language=en_US",
  google: "https://www.google.com/maps/place/Higher+Ground+DC+Cannabis+Dispensary/@38.9133427,-76.9888204,722m/data=!3m2!1e3!4b1!4m6!3m5!1s0x89b7b9df9e6854e3:0x5bcb0c4521aef9d3!8m2!3d38.9133427!4d-76.9888204!16s%2Fg%2F11ytfyx54x",
  mapEmbed: "https://www.google.com/maps?q=1135+Okie+St+NE+Washington+DC+20002&output=embed",
  phone: "+12028001135",
};

export const ADDRESS = { line1: "1135 Okie St NE", line2: "Washington, DC 20002" };

export const NAV = [
  { label: "Home", to: "/" },
  { label: "Shop", to: "/shop" },
  { label: "About", to: "/about" },
  { label: "Events", to: "/events" },
  { label: "Media", to: "/media" },
  { label: "Areas Served", to: "/areas-served" },
  { label: "Blog", to: "/blog" },
  { label: "Contact", to: "/contact" },
];

export const CATEGORIES = [
  { name: "Flower", url: "https://highergroundcannabis.dispensary.shop/med/flower/nb/5af" },
  { name: "Prerolls", url: "https://highergroundcannabis.dispensary.shop/med/prerolls/nb/5ag" },
  { name: "Edibles", url: "https://highergroundcannabis.dispensary.shop/med/edibles/nb/5ah" },
  { name: "Cartridges & Vapes", url: "https://highergroundcannabis.dispensary.shop/med/cartridges-%26-vapes/nb/5ai" },
  { name: "Concentrates", url: "https://highergroundcannabis.dispensary.shop/med/concentrates/nb/5aj" },
  { name: "Tinctures", url: "https://highergroundcannabis.dispensary.shop/med/tinctures/nb/5ak" },
];

export const BEST_SELLERS = [
  {
    brand: "Molecular Farms",
    name: "Lemon Cherry Gelato - Preroll - 1g",
    type: "Indica-dom",
    thc: "THC: 21.33%",
    price: "$8.50",
    unit: "/1g",
    image: "https://highergroundcannabis.dispensary.shop/assets/product_image_placeholder-BpIeC0uw.svg",
    url: "https://highergroundcannabis.dispensary.shop/med/joints/pdp/lemon-cherry-gelato-preroll-1g/v/d84fbcc6-927f-4fa6-ad56-d248715f129c",
  },
  {
    brand: "Molecular Farms",
    name: "Honey Banana .7g Preroll",
    type: "50/50",
    thc: "THC: 17.73%",
    price: "$6.00",
    unit: "/0.7g",
    image: "https://origin.dispensary.shop/cdn-cgi/image/quality=80,format=webp/https://storage.googleapis.com/maui-prod-hyper-media-images/product_images_31e7a606-f7a0-48ff-a5b3-973c6205bfe5_f2a7cfcd-b48e-44fb-8771-949802bef233_mobile.png",
    url: "https://highergroundcannabis.dispensary.shop/med/joints/pdp/honey-banana-.7g-preroll/v/851a627a-f502-4abc-a95d-49d333e745c0",
  },
  {
    brand: "Alt Sol",
    name: "Fuel Biscuits - Flower - 3.5g",
    type: "Indica-dom",
    thc: "THC: 25%",
    price: "$42.00",
    unit: "/3.5g",
    image: "https://origin.dispensary.shop/cdn-cgi/image/quality=80,format=webp/https://storage.googleapis.com/maui-prod-hyper-media-images/product_images_69c9d3b4-d0a8-4882-a2d7-d2434fd4daaf_717ab75e-3b48-4eff-925f-e1b02f08affc_mobile.png",
    url: "https://highergroundcannabis.dispensary.shop/med/flower/pdp/fuel-biscuits-flower-3.5g/v/e287b20a-fce8-4c9e-9ea8-b0ae39a3eabd",
  },
  {
    brand: "Molecular Farms",
    name: "Clementine - Preroll - 0.7g",
    type: "Hybrid",
    thc: "THC: 13.88%",
    price: "$6.00",
    unit: "/0.7g",
    image: "https://highergroundcannabis.dispensary.shop/assets/product_image_placeholder-BpIeC0uw.svg",
    url: "https://highergroundcannabis.dispensary.shop/med/joints/pdp/clementine-preroll-0.7g/v/649608e2-825f-47cd-aee0-0e962ff8fabe",
  },
  {
    brand: "Khalifa Kush",
    name: "Khalifa Mints - Flower - 3.5g",
    type: "Hybrid",
    thc: "THC: 27.48%",
    price: "$40.00",
    unit: "/3.5g",
    image: "https://origin.dispensary.shop/cdn-cgi/image/quality=80,format=webp/https://storage.googleapis.com/maui-prod-hyper-media-images/global_raw_brand_images_26c4481b-bf44-4b3f-bdd9-500995acdf38_acea8be7-b8e9-48c3-a2de-f5f253826dfa_mobile.png",
    url: "https://highergroundcannabis.dispensary.shop/med/flower/pdp/khalifa-mints-flower-3.5g/v/e3701c1b-89da-4221-b362-2f2a658c8cc1",
  },
  {
    brand: "Choof",
    name: "King's Juice - Flower - 3.5g",
    type: "Sativa-dom",
    thc: "THC: 19.45%",
    price: "$28.00",
    unit: "/3.5g",
    image: "https://origin.dispensary.shop/cdn-cgi/image/quality=80,format=webp/https://storage.googleapis.com/maui-prod-hyper-media-images/product_images_b56bcd04-933b-49cf-a892-0601c8c45250_8e98ad7b-f469-4606-8d0b-cb27a1780b4e_mobile.png",
    url: "https://highergroundcannabis.dispensary.shop/med/flower/pdp/king's-juice-flower-3.5g/v/5cb8f033-e06f-4b18-872b-89208272b045",
  },
];

export const PILLARS = [
  {
    n: "01",
    title: "Premium Quality",
    body: "Every product is thoughtfully curated to meet the highest quality standards.",
  },
  {
    n: "02",
    title: "Expert Staff",
    body: "Our staff lives for the plant. Bring us your questions, and our team will help you find the right strength and consumption method for your desired effect.",
  },
  {
    n: "03",
    title: "Luxury Experience",
    body: "Our space was designed to be welcoming and refined. New consumers and connoisseurs alike will feel at home at Higher Ground DC.",
  },
];

export const EVENT_IMAGES = {
  magic: ASSETS.comedyStage,
  soma: ASSETS.yogaFlow,
  art: ASSETS.groupPatio,
  pilates: ASSETS.soundBath,
  candle: "https://customer-assets-jai6qajn.emergentagent.net/job_hgdc-preview/artifacts/bvqrlbie_Candle%20Pouring%20Class.webp",
  anime: "https://customer-assets-jai6qajn.emergentagent.net/job_hgdc-preview/artifacts/3idxk8i1_JULY%20PAGE%2003.webp",
  comedy: "https://customer-assets-jai6qajn.emergentagent.net/job_hgdc-preview/artifacts/epmdsnls_HG-HIGLY%20INAPROPRIATE%20COMEDY%20FLYER2.png",
  producer: "https://customer-assets-jai6qajn.emergentagent.net/job_hgdc-preview/artifacts/kcn6sya4_HG-PRODUCER%20CON-FLYER4.png",
  yoga: "https://customer-assets-jai6qajn.emergentagent.net/job_hgdc-preview/artifacts/vbjr209y_FLYER%20ASL%20YOGA.png",
};

export const EVENTS = [
  {
    month: "Aug", day: "16", iso: "2026-08-16",
    title: "Pilates & Sound Bath",
    host: "Higher Ground DC x Oak Pilates Club",
    time: "Sun, Aug 16 · 10:00 – 11:30 AM",
    body: "Guided movement, sound healing & a mindful reset by Oak Pilates.",
    cta: { label: "Tickets", href: "https://www.eventbrite.com/e/pilates-sound-bath-oak-pilates-higher-ground-tickets-1994990903496?aff=oddtdtcreator" },
    image: EVENT_IMAGES.pilates,
  },
  {
    month: "Aug", day: "16", iso: "2026-08-16",
    title: "Elevated Candle Making",
    host: "Higher Ground DC x Irie Essence",
    time: "Sun, Aug 16 · 5:00 – 7:00 PM",
    body: "Pour, create & unwind — craft and community with Irie Essence.",
    cta: { label: "Tickets", href: "https://www.eventbrite.com/e/1994984016898?aff=oddtdtcreator" },
    image: EVENT_IMAGES.candle,
  },
  {
    month: "Aug", day: "21", iso: "2026-08-21",
    title: "Monthly Art Showcase",
    host: "Higher Ground DC",
    time: "Fri, Aug 21 · 6:00 – 8:00 PM",
    body: "DC art on display: local voices, live culture, curated walls.",
    cta: { label: "Get Event Updates", to: "/signup" },
    image: ASSETS.exteriorWide,
  },
  {
    month: "Sep", day: "24", iso: "2026-09-24",
    title: "ASL Yoga with Doobie Dreubie",
    host: "Higher Ground DC x Doobie Dreubie",
    time: "Thu, Sep 24 · 6:00 – 7:30 PM",
    body: "Join Instructor Dreu for a 420 & Deaf-friendly, all-level gentle flow taught in ASL. Don't know ASL? No problem — it's easy to follow along (voice interpreting available on request). Bring your mat, towel, and water, and arrive 10 minutes early. Free parking directly across the street. 21+ · valid medical card required.",
    cta: { label: "Tickets", href: "https://www.eventbrite.com/e/asl-yoga-with-doobie-dreubie-at-higher-ground-tickets-2001054043511?aff=oddtdtcreator" },
    image: "https://customer-assets-jai6qajn.emergentagent.net/job_hgdc-preview/artifacts/e4oucuad_PHOTO-2026-09-15-13-25-32.jpg",
  },
  /* HIDDEN — Comedy Show being rescheduled (uncomment + update date to restore)
  {
    month: "Sep", day: "25", iso: "2026-09-25",
    title: "Comedy Show",
    host: "Higher Ground DC",
    time: "Fri, Sep 25 · Doors 7 PM · Show 8 PM",
    body: "A night of laughs under the lights on the Higher Ground patio. Fresh lineup, great crowd, no bad seats. 21+ with valid ID · medical patients welcome with valid card.",
    cta: { label: "Get Event Updates", to: "/signup" },
    image: "https://customer-assets-jai6qajn.emergentagent.net/job_hgdc-preview/artifacts/xfyn1o5e_PHOTO-2026-09-15-13-22-14.jpg",
  },
  */
  {
    month: "Oct", day: "10", iso: "2026-10-10",
    title: "Stretch, Sip & Flow",
    host: "Higher Ground DC",
    time: "Sat, Oct 10 · 1:00 – 3:00 PM",
    body: "Healing with Tiera, in collaboration with Gifts From Nature, presents an elevated wellness experience blending movement, sound, and herbal wellness — an intentional Vinyasa yoga flow, a restorative sound bath, and an herbal-infused sip. Enjoy light refreshments and a Gifts From Nature pop-up. Bring your yoga mat, an open mind, and good energy. 21+ · valid medical card required.",
    cta: { label: "Tickets", href: "https://www.eventbrite.com/e/stretch-sip-flow-at-higher-ground-dispensary-tickets-1996990268651?aff=oddtdtcreator" },
    image: "/stretch-sip-flow-flyer.png",
  },
  {
    month: "Sep", day: "26", iso: "2026-09-26",
    title: "Candle Pouring Class",
    host: "Higher Ground DC",
    time: "Sat, Sep 26 · 5:00 – 7:00 PM",
    body: "Join Irie Essence for an elevated evening of candle pouring, music, and curated vibes — celebrating growth, community, and unforgettable experiences. Expect a hands-on candle-making experience, good music, and great energy in a relaxed, social atmosphere. 21+ · valid medical card required · all cannabis must be purchased from Higher Ground.",
    cta: { label: "Tickets", href: "https://www.eventbrite.com/e/puff-pour-elevated-candle-making-tickets-1999208416190?aff=oddtdtcreator" },
    image: "https://customer-assets-jai6qajn.emergentagent.net/job_hgdc-preview/artifacts/c38jw8i8_HG-CANDLE-POURING_GOLD-POUR_2026-09-22.png",
  },
  {
    month: "Oct", day: "31", iso: "2026-10-31",
    title: "High Girl Walk Meet Up",
    host: "Walk Club × Higher Ground",
    time: "Sat, Oct 31 · 10:00 AM – 12:00 PM",
    body: "Walk in community with HI. Women's Cannabis Collective — meet friends, get your steps in, and explore plant-based wellness in a safe space. Meet at Higher Ground for exclusive HI. Girl deals (smoke in the indoor lounge or on the patio), then we step off at 10:30 AM. Afterward: specialty lemonade by Golden Hour and a charm bar by Sweeder. 21+ · valid medical card required.",
    cta: { label: "Tickets", href: "https://partiful.com/e/PYTV9FAwR7h4rftJnnZB" },
    image: "/high-girl-walk-flyer.png",
  },
  {
    month: "Oct", day: "3", iso: "2026-10-03",
    title: "Movie Night with The Hitter's Club 93",
    host: "The Hitter's Club 93",
    time: "Sat, Oct 3 · 5:00 – 8:00 PM",
    body: "Vintage cinema, music, and games. The Hitter's Club 93 presents an immersive film festival — two vintage psychedelic films with music, games, film discussion, and an optional listening experience (private playlist for attendees). Free entry, limited availability. 21+ with valid ID · medical patients welcome with valid card.",
    cta: { label: "Tickets", href: "https://www.eventbrite.com/e/the-hitters-club-93-presents-film-festival-tickets-1999395828746?aff=erelpanelorg" },
    image: "https://customer-assets-jai6qajn.emergentagent.net/job_hgdc-preview/artifacts/jt1qp1d0_the%20hitters%20club%20.webp",
  },
  {
    month: "Oct", day: "16", iso: "2026-10-16",
    title: "Feel Good Fridays Comedy Night",
    host: "Higher Ground x Feel Good Flavors",
    time: "Fri, Oct 16 · Doors 6:30 PM · Show 8 PM",
    body: "A night of laughs with 5 of the best DMV comedians, hosted by Higher Ground and Feel Good Flavors. Arrive early to browse the dispensary and get comfy — the first act starts at 8. Free parking in our private lot across the street. 21+ 420-friendly with valid ID · medical patients welcome with valid card.",
    cta: { label: "Tickets", href: "https://www.eventbrite.com/e/feel-good-fridays-comedy-night-tickets-2002317694124?aff=oddtdtcreator" },
    image: "/feel-good-fridays-flyer.png",
  },
  {
    month: "Oct", day: "22", iso: "2026-10-22",
    title: "Puff & Paint with Loud Vybz",
    host: "Higher Ground x Loud Vybz",
    time: "Thu, Oct 22 · 7:00 – 9:00 PM",
    body: "Puff & Paint at Higher Ground led by Loud Vybz — a night of art, creativity, community, and elevated vibes. Follow the instructor or choose your own adventure and paint at your own pace, then take your masterpiece home. All materials provided. Doors 6:30 PM. 21+ 420-friendly with valid ID · medical patients welcome with valid card.",
    cta: { label: "Tickets", href: "https://www.eventbrite.com/e/puff-paint-with-higher-ground-x-loud-vybz-tickets-2002340955700?aff=oddtdtcreator" },
    image: "/puff-paint-flyer.png",
  },
  {
    month: "Oct", day: "24", iso: "2026-10-24",
    title: "Puff & Pour: Candle Pouring Class",
    host: "Higher Ground DC x Irie Essence",
    time: "Sat, Oct 24 · 5:00 – 7:00 PM",
    body: "Puff & Pour returns — join Irie Essence for an elevated evening of candle pouring, music, creativity, and curated vibes celebrating growth, community, and unforgettable experiences. Expect a hands-on candle-making experience, good music, and great energy in a relaxed, social atmosphere. 21+ · valid medical card required · all cannabis must be purchased from Higher Ground.",
    cta: { label: "Tickets", href: "https://www.eventbrite.com/e/puff-pour-elevated-candle-making-tickets-2002811982554?aff=oddtdtcreator" },
    image: "/candle-pouring-flyer.png",
  },
  {
    month: "Oct", day: "29", iso: "2026-10-29",
    title: "Tea Pad DC: Legal Ninety Years Later",
    host: "The Tea Pad Foundation",
    time: "Thu, Oct 29 · 6:00 – 9:00 PM",
    body: "A one-of-a-kind cannabis networking night in a licensed consumption lounge — three miles from the Capitol. Ninety years after the 1920s jazz-scene 'tea pads,' the name is finally the venue. Enjoy live jazz from the Eric Scott Trio, infused & functional beverages, and cross-market conversation uniting Maryland, DC & Virginia — all raising funds for The Tea Pad Fellowship, empowering women in cannabis. 21+ · valid medical card required · consumption optional.",
    cta: { label: "Tickets", href: "https://www.eventbrite.com/e/tea-pad-dc-legal-ninety-years-later-were-legal-in-dc-tickets-1999718095655" },
    image: "https://customer-assets-jai6qajn.emergentagent.net/job_hgdc-preview/artifacts/ky6jlgrh_image%20%282%29.webp",
  },
  /* HIDDEN — Pokemon and Card Swap postponed (uncomment to restore)
  {
    month: "Oct", day: "24", iso: "2026-10-24",
    title: "Pokemon and Card Swap",
    host: "Higher Ground DC",
    time: "Sat, Oct 24 · 12:00 – 4:00 PM",
    body: "Trade, battle, and connect at Higher Ground's Pokemon and Card Swap. Bring your binders and decks for an afternoon of trading and friendly play with fellow collectors. 21+ with valid ID · medical patients welcome with valid card.",
    cta: { label: "Get Event Updates", to: "/signup" },
    image: ASSETS.exteriorWide,
  },
  */
  {
    month: "Aug", day: "30", iso: "2026-08-30",
    title: "Pilates & Sound Bath",
    host: "Oak Pilates × Higher Ground",
    time: "Sun, Aug 30 · 10:00 – 11:30 AM",
    body: "Guided movement, sound healing & a mindful reset by Oak Pilates at Higher Ground — 1135 Okie St NE, Washington, DC. 21+ with valid ID · medical patients welcome with valid card.",
    cta: { label: "Tickets", href: "https://www.eventbrite.com/e/pilates-sound-bath-oak-pilates-higher-ground-tickets-1994990903496" },
    image: EVENT_IMAGES.pilates,
  },
  {
    month: "Sep", day: "12", iso: "2026-09-12",
    title: "Flavor & Flow Fest",
    host: "DMV Eats × Higher Ground",
    time: "Sat, Sep 12 · 2:00 – 9:00 PM",
    body: "End your summer on a high note! Amazing DMV food trucks, raffles & prizes, art exhibits, and brand pop-ups at 1135 Okie St NE, Washington, DC. 21+ to enter.",
    cta: { label: "Tickets", href: "https://www.eventbrite.com/e/flavor-flow-fest-by-dmveats-higher-ground-tickets-1997278690328?utm_experiment=test_share_listing&aff=ebdsshios" },
    image: "https://customer-assets-jai6qajn.emergentagent.net/job_hgdc-preview/artifacts/ewaipciz_PHOTO-2026-08-24-12-34-15.webp",
  },
  {
    month: "Sep", day: "11", iso: "2026-09-11",
    title: "Weedini — A Magical 420 Experience",
    host: "Higher Ground DC",
    time: "Fri, Sep 11",
    body: "A magical 420 experience at Higher Ground — mind-bending illusions and good vibes. 21+ with valid ID · medical patients welcome with valid card.",
    cta: { label: "Tickets", href: "https://www.eventbrite.com/e/weedini-a-magical-420-experience-tickets-1996987426149" },
    image: "https://customer-assets-jai6qajn.emergentagent.net/job_hgdc-preview/artifacts/0uc9lers_PHOTO-2026-09-06-09-42-43.jpg",
  },
];

// Returns only events happening today or later (past events auto-drop off).
export const getUpcomingEvents = () => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return EVENTS
    .filter((e) => {
      const [y, m, d] = e.iso.split("-").map(Number);
      return new Date(y, m - 1, d) >= today;
    })
    .sort((a, b) => (a.iso < b.iso ? -1 : a.iso > b.iso ? 1 : 0));
};

// Next upcoming event (or null if none scheduled) — powers the homepage "Next Event" module.
export const getNextEvent = () => getUpcomingEvents()[0] || null;

// This Week's Deals — edit these weekly. Keep to 1–3 cards.
// Each card: { deal: "[Product/Category] - [exact offer]", fine: "[Dates] · While supplies last · 21+" }
export const DEALS = [
  { deal: "Tuesday Happy Hour — 15% Off", fine: "Tuesdays only · While supplies last · 21+" },
  { deal: "1¢ Preroll with $65+ Purchase", fine: "Tuesdays only · While supplies last · 21+" },
];

export const TESTIMONIALS = [
  { name: "Marcus T.", when: "2 weeks ago", quote: "Best dispensary in DC hands down! The staff is incredibly knowledgeable and helped me find exactly what I needed. The space is beautiful and welcoming." },
  { name: "Ashley R.", when: "1 month ago", quote: "Higher Ground DC is a game changer. Premium quality products and the most helpful budtenders I've ever met. They took the time to explain everything." },
  { name: "David K.", when: "3 weeks ago", quote: "Amazing experience from start to finish. Clean, modern space with top-tier products. The staff really knows their stuff and the prices are fair for the quality." },
  { name: "Jennifer M.", when: "1 month ago", quote: "Finally a dispensary that feels like a real boutique experience! Love the attention to detail and the curated selection. My new go-to spot in DC." },
];

export const AREAS_DC = [
  "Adams Morgan", "Capitol Hill", "Columbia Heights", "Chinatown", "Georgetown",
  "Logan Circle", "Dupont Circle", "U Street Corridor", "NoMa", "Union Market District",
  "Brookland", "Petworth", "Shaw", "Foggy Bottom", "Navy Yard", "The Wharf",
  "H Street Corridor", "Tenleytown", "Cleveland Park", "Chevy Chase DC",
  "Forest Hills", "Brightwood", "Fort Totten",
];

export const AREAS_MD = [
  "Bethesda", "Silver Spring", "Takoma Park", "Rockville",
  "College Park", "Hyattsville", "Greenbelt", "Laurel",
];

// SEO location guides — mirrors highergrounddc.com/dispensary/<slug>
export const AREA_GUIDES = [
  { slug: "capitol-hill", name: "Capitol Hill", region: "Washington, DC", blurb: "A quick trip from the Hill to premium, patient-first medical cannabis near Union Market." },
  { slug: "georgetown", name: "Georgetown", region: "Washington, DC", blurb: "Serving Georgetown with curated flower, vapes, and edibles just across the city." },
  { slug: "dupont-circle", name: "Dupont Circle", region: "Washington, DC", blurb: "Dupont Circle's neighbors trust Higher Ground DC for guidance and quality." },
  { slug: "union-market", name: "Union Market", region: "Washington, DC", blurb: "Our home neighborhood — steps from the Union Market district." },
  { slug: "noma", name: "NoMa", region: "Washington, DC", blurb: "Convenient premium cannabis for the North of Massachusetts Ave community." },
  { slug: "navy-yard", name: "Navy Yard", region: "Washington, DC", blurb: "A short ride from Navy Yard to an elevated dispensary experience." },
  { slug: "u-street", name: "U Street", region: "Washington, DC", blurb: "Serving the U Street corridor with a refined, patient-first retail experience." },
  { slug: "shaw", name: "Shaw", region: "Washington, DC", blurb: "Shaw locals shop premium flower and edibles at Higher Ground DC." },
  { slug: "petworth", name: "Petworth", region: "Washington, DC", blurb: "Easy access from Petworth to curated cannabis and expert guidance." },
  { slug: "columbia-heights", name: "Columbia Heights", region: "Washington, DC", blurb: "Columbia Heights neighbors welcome at our Northeast DC destination." },
  { slug: "brookland", name: "Brookland", region: "Washington, DC", blurb: "Close to Brookland for trusted, transparent medical cannabis." },
  { slug: "foggy-bottom", name: "Foggy Bottom", region: "Washington, DC", blurb: "Serving Foggy Bottom with a luxury boutique cannabis experience." },
  { slug: "adams-morgan", name: "Adams Morgan", region: "Washington, DC", blurb: "Adams Morgan's go-to for premium, patient-first cannabis in DC." },
  { slug: "silver-spring", name: "Silver Spring", region: "Maryland", blurb: "A short trip from Silver Spring, MD to Washington DC's premier dispensary." },
  { slug: "bethesda", name: "Bethesda", region: "Maryland", blurb: "Bethesda, MD patients and visitors welcome with valid credentials." },
];

export const AREAS = [
  { name: "Union Market", note: "Steps from the market district — our home neighborhood." },
  { name: "Ivy City", note: "A short ride from DC's fastest-growing creative quarter." },
  { name: "NoMa", note: "Serving the North of Massachusetts Ave community." },
  { name: "H Street NE", note: "Convenient for the H Street corridor & Atlas District." },
  { name: "Trinidad", note: "Welcoming neighbors from the historic Trinidad area." },
  { name: "Eckington", note: "Close to the Eckington & Bloomingdale line." },
  { name: "Brentwood", note: "Easy access for Brentwood residents & visitors." },
  { name: "Capitol Hill", note: "A quick trip from the Hill for trusted guidance." },
];

export const BLOG_POSTS = [
  {
    slug: "cannabis-yoga-sound-bath-washington-dc",
    title: "Cannabis Yoga & Sound Baths in Washington DC",
    excerpt: "Where to find 420-friendly yoga, breathwork, and sound healing in DC — inside Higher Ground's outdoor wellness garden near Union Market.",
    date: "September 2026",
    category: "Wellness Events",
  },
  {
    slug: "asl-yoga-deaf-friendly-cannabis-class-dc",
    title: "ASL Yoga: A Deaf-Friendly, 420-Friendly Class in DC",
    excerpt: "An inclusive, ASL-guided yoga flow with Doobie Dreubie at Higher Ground DC — open to all levels, hearing and Deaf alike.",
    date: "September 2026",
    category: "Wellness Events",
  },
  {
    slug: "cannabis-candle-making-class-dc",
    title: "Puff & Pour: Cannabis Candle-Making Classes in DC",
    excerpt: "Hand-pour your own candle at a social, 21+ candle-making class in Washington DC — music, community, and craft at Higher Ground.",
    date: "September 2026",
    category: "Community",
  },
  {
    slug: "womens-cannabis-community-walk-dc",
    title: "The High Girl Walk: Women's Cannabis Wellness in DC",
    excerpt: "A women-led community walk pairing movement, plant-based wellness, and connection — meeting at Higher Ground DC near NoMa.",
    date: "September 2026",
    category: "Community",
  },
  {
    slug: "tea-pad-dc-cannabis-networking-jazz",
    title: "Tea Pad DC: Cannabis Networking, Jazz & History",
    excerpt: "Ninety years after the 1920s 'tea pads,' cannabis networking returns to DC — live jazz, three markets, and women in the industry.",
    date: "October 2026",
    category: "Community",
  },
  {
    slug: "is-weed-legal-in-washington-dc",
    title: "Is Weed Legal in Washington DC? A Visitor's Guide",
    excerpt: "What's legal, what you need, and how to shop cannabis legally in Washington DC — including medical registration and self-certification.",
    date: "September 2026",
    category: "Access",
  },
  {
    slug: "best-cannabis-dispensaries-washington-dc",
    title: "The Higher Ground DC Difference: Expertise You Can Trust",
    excerpt: "What separates a good dispensary from a great one — and how our patient-first team earns your trust every visit.",
    date: "Coming Soon",
    category: "Our Expertise",
  },
  {
    slug: "what-to-expect-washington-dc-dispensary",
    title: "First Time? What to Expect at Higher Ground DC",
    excerpt: "For first-time and experienced consumers alike — from registration to your first consultation, here's how a visit works.",
    date: "Coming Soon",
    category: "Build Trust",
  },
  {
    slug: "indica-vs-sativa-vs-hybrid-explained",
    title: "Cannabis Science, Made Simple: Indica vs Sativa vs Hybrid",
    excerpt: "We explain the science in plain language so you can choose formats and effects with confidence.",
    date: "Coming Soon",
    category: "Cannabis Science",
  },
  {
    slug: "best-cannabis-strains-anxiety-sleep",
    title: "Responsible Consumption: Guidance for Anxiety & Sleep",
    excerpt: "A gentle, educational look at calming cultivars and dosing mindfully for rest and relief.",
    date: "Coming Soon",
    category: "Responsible Use",
  },
  {
    slug: "how-to-get-medical-cannabis-card-dc",
    title: "How to Get a Medical Cannabis Card in DC",
    excerpt: "A step-by-step overview for DC residents and visitors registering to purchase.",
    date: "Coming Soon",
    category: "Access",
  },
  {
    slug: "inside-higher-ground-dc-cannabis-lounge",
    title: "Inside the Higher Ground DC Cannabis Lounge",
    excerpt: "A look at our elevated lounge experience — designed to be welcoming, refined, and unmistakably DC.",
    date: "Coming Soon",
    category: "The Lounge",
  },
  {
    slug: "terpenes-cannabinoids-new-strains-explained",
    title: "Terpenes, Cannabinoids & New Strains, Demystified",
    excerpt: "Meet the compounds behind aroma and effect, plus a look at the newest products and strains on our shelves.",
    date: "Coming Soon",
    category: "New Products",
  },
  {
    slug: "responsible-cannabis-consumption-guide",
    title: "A Practical Guide to Responsible Cannabis Consumption",
    excerpt: "Start low, go slow: dosing, formats, and mindful habits for a safe, enjoyable experience.",
    date: "Coming Soon",
    category: "Responsible Use",
  },
  {
    slug: "community-events-at-higher-ground-dc",
    title: "Community & Events at Higher Ground DC",
    excerpt: "From comedy nights to sound baths — a recap of the lounge experiences that bring our community together.",
    date: "Coming Soon",
    category: "Community",
  },
];

export const HOURS = "Mon–Sat 12–8 PM · Sun 12–7 PM";

export const LISTINGS = [
  {
    category: "Government / Regulatory",
    items: [{ label: "DC ABCA Registry", href: "https://abca.dc.gov/" }],
  },
  {
    category: "Industry Directories",
    items: [{ label: "CannabisPromotions", href: "https://cannabispromotions.com/" }],
  },
  {
    category: "Local Listings / Maps",
    items: [
      { label: "Google Business Profile", href: "https://www.google.com/maps/place/Higher+Ground+DC+Cannabis+Dispensary" },
      { label: "Apple Maps", href: "https://maps.apple.com/?q=Higher+Ground+DC+Cannabis+Dispensary" },
    ],
  },
  {
    category: "Social Signals",
    items: [
      { label: "Instagram — @highergrounddc", href: "https://www.instagram.com/highergrounddc" },
      { label: "Instagram Post", href: "https://www.instagram.com/p/DXUVMJdDUwD/" },
      { label: "Instagram Post", href: "https://www.instagram.com/p/DXXqXgAjVsi/" },
    ],
  },
  {
    category: "Media Mentions",
    items: [
      { label: "WTOP Article", href: "https://wtop.com/?s=Higher+Ground+DC" },
      { label: "WTOP Facebook", href: "https://www.facebook.com/wtopnews" },
      { label: "Axios Feature", href: "https://www.axios.com/local/washington-dc" },
      { label: "PoPville Feature", href: "https://www.popville.com/?s=Higher+Ground+DC" },
    ],
  },
];

export const FAQ_GROUPS = [
  {
    category: "Age, Access & Registration",
    items: [
      { q: "Do I need to be 21+ to enter Higher Ground DC?", a: "Yes. You must be 21 or older with a valid government-issued ID to enter. Medical cannabis products are for registered patients." },
      { q: "Do non-DC residents need medical cannabis registration to shop in Washington DC?", a: "Non-DC residents can purchase from any licensed DC retailer by registering for a temporary DC patient registration, or by using a valid medical cannabis ID from any state." },
      { q: "Where can I learn about the medical marijuana card DC process?", a: "DC residents register with a DC patient registration. You can start your application from our Medical Cannabis Access section, or ask our team for guidance." },
      { q: "What should I bring for my first Higher Ground DC dispensary visit?", a: "A valid 21+ government-issued ID, and your medical registration or ID if applicable. Good news — no waiver is needed for general entry. You'd only complete our Safe Use Waiver if you plan to visit the Safe Use Treatment Facility or Summer Garden." },
      { q: "Is Higher Ground DC a medical weed dispensary near me if I am in Northeast DC?", a: "Yes — we're located at 1135 Okie St NE near Union Market, proudly serving Northeast DC and surrounding neighborhoods." },
    ],
  },
  {
    category: "Menu & Product Questions",
    items: [
      { q: "Can I browse the Higher Ground DC dispensary menu online?", a: "Yes — our live Flowhub menu is online and refreshed throughout the day so you always see current inventory." },
      { q: "What product types does Higher Ground DC cannabis carry?", a: "Premium flower, prerolls, vapes and cartridges, concentrates, edibles, and tinctures." },
      { q: "Does Higher Ground DC offer CBD flower and pre-roll options?", a: "We carry a curated range that includes CBD-forward options and prerolls. CBD content varies by product, so check the label or ask our staff." },
      { q: "How should I choose between flower, edibles, and vapes at a Washington DC dispensary?", a: "Consider onset and duration — flower and vapes act quickly, while edibles have a delayed onset and last longer. Our expert staff helps match strength and format to your desired effect." },
      { q: "Is the Higher Ground DC shop page the same as the live menu?", a: "The Shop page showcases best sellers and categories and links to the live Flowhub menu, which reflects real-time inventory, potency, and pricing." },
    ],
  },
];
